import { Metadata } from "./AppModel";

export enum EapProgram {
  EAP_YELLOW = "EAP YELLOW",
  EAP_GREEN = "EAP GREEN",
  EAP_ACCESS = "EAP ACCESS",
}
export interface School extends Metadata {
  subscribedPrograms: EapProgram[];
  photoUrl?: string;
  name: string;
  city: string;
  country: string;
  principalName?: string | null;
  principalId?: string | null;
  _id?: string;
  isActive: boolean;
}
